import { axiosInstance } from "@helpers/axios-instance";
import type { FinancialAccount, LTIPDataAwareResponse, LTIPResponseWrapper } from "../types/types";
import { useQueryWithValidation } from "./useQueryWithValidation";

export function useLTIP(
  householdExternalCode: string,
  type: FinancialAccount["accountType"],
  selectedClient?: string | null | undefined
) {
  const typeToPathTranslation: Record<
    Exclude<FinancialAccount["accountType"], undefined>,
    string
  > = {
    SARs: "stock-appreciation-rights",
    RSU: "restricted-stock-awards",
    PSU: "performance-stock-awards",
    CDP: "compensation-deferral-plan",
    DCP: "deferred-compensation-plan",
    SRP: "savings-restoration-plan",
    DLTIP: "deferred-long-term-incentive-plan",
  };

  const typeToUse = typeToPathTranslation[type as keyof typeof typeToPathTranslation] || type;

  return useQueryWithValidation<LTIPResponseWrapper>({
    queryKey: [String(typeToUse), householdExternalCode, String(selectedClient)],
    queryFn: async () => {
      const data = await axiosInstance<LTIPDataAwareResponse>({
        method: "GET",
        url: `Salesforce/LTIP/${type}/${householdExternalCode}`,
      });

      const fas = data.data.data.financialAccounts;

      let newWrapper: LTIPResponseWrapper = {
        ...data.data.data,
      };

      if (selectedClient) {
        const newData = fas?.filter((d) => d.ownerId === selectedClient);

        newWrapper.financialAccounts = newData;

        return {
          ...data.data,
          data: newWrapper,
        };
      }

      return data.data;
    },
    enabled: !!householdExternalCode,
  });
}
